import gqlClient from 'Utils/graphql-client/graphqlClient';

const getDataScore = ({
  resortId,
  departureDate,
  appContext,
}: {
  resortId?: string,
  departureDate?: string,
  appContext: AppContext,
}) => {
  const { neolaneId, googleTrackingId } = appContext;
  return gqlClient.runNoCacheQuery(`
    query{
      dataScore(
      resortId: "${resortId || ''}",
      departureDate: "${departureDate || ''}",
      neolaneId: "${neolaneId || ''}",
      gaTrackingId: "${googleTrackingId || ''}") {
        leadScoring
      }
    }
  `);
};

export { getDataScore };
